export enum SellableProjectProductType {
  IEC_COMMERCIAL = 'IEC_COMMERCIAL',
  CLM_COMMERCIAL = 'CLM_COMMERCIAL',
  CLM_RESIDENTIAL = 'CLM_RESIDENTIAL'
}
